
import ManagementCompanyDetailInfo from "./ManagementCompanyDetailInfo";
import ManagementCompanyNotesForm from "./ManagementCompanyNotes";
import ManagementCompanyCertificateNotesForm from "./ManagementCompanyCertificateNotes";
import ManagementCompanyContactForm from "./ManagementCompanyContact";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";


const ManagementCompanyDetailsForm = () => {

    return (
        <>
            <div className="md:grid grid-cols-12 gap-4 mt-3">

                <div className="col-span-6 space-y-4">
                    <ManagementCompanyDetailInfo isReadOnly={hasPermission(["MGTCOM-U"]) === false} />
                    <ManagementCompanyContactForm />
                </div>


                <div className="col-span-6">
                    <ManagementCompanyNotesForm />
                    {hasPermission(["CRTNOT-V"]) &&
                        <ManagementCompanyCertificateNotesForm />}
                </div>
            </div>
        </>
    );
};

export default ManagementCompanyDetailsForm;